import { Box } from "@drone-js/core";
import { Outlet } from "react-router";

const Layout = () => {
    return (
        <>
            <Box
                display="flex"
                maxWidth="632px"
                height="100dvh"
                m="auto"
                flexDirection="column"
                justifyContent="center"
            >
                <Outlet />
            </Box>
        </>
    );
};

export default Layout;
